import { call, put, takeLatest } from 'redux-saga/effects';
import {
    GetDncStatus,
    ComplianceEndpoint,
    DncStatusResponse,
    CreateContactAttempt,
    CreateContactAttemptParams,
    DncQueryParams,
    DncStatusApiResponse
} from '../actions/compliance_actions';
import { Strings } from '../assets/common/strings';
import { http } from '../utilities';

function* createContactAttemptStatusSaga(action: ReturnType<typeof CreateContactAttempt.started>) {
    const params = action.payload;    
    try {
        const response: Response = yield call(
            fetchComplianceClient,
            params,
            ComplianceEndpoint.CreateContactAttempt
        );

        if (!response.ok) {
            const text = yield response.text();
            throw new Error(`HTTP ${response.status}: ${text}`);
        }
        
        yield put(CreateContactAttempt.done({
            params: action.payload,
            result: undefined
        }));

    } catch (error) {
        yield put(CreateContactAttempt.failed({
            params: action.payload,
            error: error instanceof Error
                ? error
                : new Error(JSON.stringify(error))
            }));
    }
}

function* getDncStatusSaga(action: ReturnType<typeof GetDncStatus.started>) {
    const params = action.payload;
    try {
        const response = yield call(
            fetchComplianceClient, params, ComplianceEndpoint.DncStatus);

        const text = yield response.text();

        if (!response.ok) {
            throw new Error(`HTTP ${response.status} : ${text}`);
        }
        
        const apiData: DncStatusApiResponse = JSON.parse(text);

        const data: DncStatusResponse = {
            phone: params.phone,
            canContact: apiData.ContactStatus?.CanContact ?? false,
            isDnc: apiData.IsDoNotCall,
            reason: apiData.ContactStatus?.Reason ?? ''
        }
        
        yield put(
            GetDncStatus.done({ 
                params, 
                result: data 
            })
        );        
    } catch (error) {
        yield put(
            GetDncStatus.failed({ 
                params, 
                error: error instanceof Error 
                    ? error 
                    : new Error(JSON.stringify(error))                
            })
        );
    }
}

// --- Watchers ---
export function* complianceSagas() {
  yield takeLatest(GetDncStatus.started, getDncStatusSaga);
  yield takeLatest(CreateContactAttempt.started, createContactAttemptStatusSaga);
}

function fetchComplianceClient(
  param: DncQueryParams | CreateContactAttemptParams,
  endpoint: ComplianceEndpoint
): Promise<Response> {
    
    switch(endpoint) {
        case ComplianceEndpoint.DncStatus: {
            const p = param as DncQueryParams;
            const query = new URLSearchParams({
                phone: p.phone,
                hasCallback: String(p.hasCallback),
                ...(p.zipCode && { zipCode: p.zipCode }),
                ...(p.businessOwner && { businessOwner: p.businessOwner }),
                ...(p.createdOn && { createdOn: p.createdOn }),
                ...(p.agentCode && { agentCode: p.agentCode })
            }).toString();

            return http(
                `compliance/dnc-status?${query}`,
                { method: Strings.Http.Get }
            );
        }

        case ComplianceEndpoint.CreateContactAttempt: {
            const p = param as CreateContactAttemptParams;
            const query = new URLSearchParams({
                phone: p.phone,
                hasCallback: String(p.hasCallback),
                ...(p.zipCode && { zipCode: p.zipCode })                    
            }).toString();

            return http(
                `compliance/contact-attempts/status?${query}`,
                { method: Strings.Http.Post }
            );
        }

        default:
        throw new Error(`Unsupported compliance endpoint: ${endpoint}`);
    }
}

